import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-row gap" }

import { onMounted, ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Editor } from '@tiptap/vue-3';
import AppModal from '../AppModal.vue';
import AppButton from '../form/AppButton.vue';
import AppFormGroup from '../form/AppFormGroup.vue';
import AppInput from '../form/AppInput.vue';

interface AppEditorLinkProps {
	editor: Editor;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppEditorLink',
  props: {
    editor: {}
  },
  emits: [
	'close',
],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();
const props = __props;
const emit = __emit;

const link = ref();

onMounted(() => {
	link.value = props.editor.getAttributes('link').href;
});

const save = () => {
	props.editor
		.chain()
		.focus()
		.extendMarkRange('link')
		.setLink({ href: link.value })
		.run();

	emit('close', link.value);
};

const remove = () => {
	props.editor
		.chain()
		.focus()
		.extendMarkRange('link')
		.unsetLink()
		.run();

	emit('close', link.value);
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(AppModal, {
    footer: false,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("h1", null, [...(_cache[2] || (_cache[2] = [
        _createTextVNode("Hantera länk", -1)
      ]))])), [
        [_directive_translate]
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(save, ["prevent"])
      }, [
        _createVNode(AppFormGroup, {
          id: "link_url",
          label: _unref($gettext)('Länkadress')
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              id: "link_url",
              placeholder: "https://...",
              type: "url",
              modelValue: link.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((link).value = $event)),
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(AppButton, { class: "t-primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("OK", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(AppButton, {
            onClick: _withModifiers(remove, ["prevent"]),
            class: "t-danger"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Ta bort länk", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})